
export default class ProductSupplier {
  public id: number
  public name: string
  public orderEmail: string
  public description: string
  public email: string
  public address1: string
  public address2: string
  public zipcode: string
  public city: string
  public country: string
  public phone: string
  public type: string
  public code: string

  public constructor(data: Record<string, unknown> = null) {
    if (!data) {
      data = {}
    }
    this.id = data.id ? (data.id as number) : null
    this.name = data.name ? (data.name as string) : null
    this.orderEmail = data.orderEmail ? (data.orderEmail as string) : null
    this.description = data.description ? (data.description as string) : null
    this.email = data.email ? (data.email as string) : null
    this.address1 = data.address1 ? (data.address1 as string) : null
    this.address2 = data.address2 ? (data.address2 as string) : null
    this.zipcode = data.zipcode ? (data.zipcode as string) : null
    this.city = data.city ? (data.city as string) : null
    this.country = data.country ? (data.country as string) : null
    this.phone = data.phone ? (data.phone as string) : null
    this.type = data.type ? (data.type as string) : null
    this.code = data.code ? (data.code as string) : null
  }
}
